/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tenant_Owner_While_PayingInputs */



/**
* | output |
* | --- |
* | "The plan is billed to you. Cancel it and wait for it to end before handing over." |
*
* @param {Tenant_Owner_While_PayingInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const tenant_owner_while_paying = /** @type {((inputs?: Tenant_Owner_While_PayingInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tenant_Owner_While_PayingInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тариф оплачиваете вы. Прежде чем передавать сервер, отмените подписку и дождитесь её окончания.")
	return /** @type {LocalizedString} */ ("The plan is billed to you. Cancel it and wait for it to end before handing over.")
});